import { Section } from 'tio-reimagined/components/layout';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import ForgivenessEstimatorForgivenessEstimatorForm from 'tio-employee/components/forgiveness-estimator/forgiveness-estimator-form';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import TioPageBreadcrumbs from 'tio-common/components/tio/page/breadcrumbs';
import type { LoanSummary } from 'tio-common/types/loan-summary';
import type RecommendationModel from 'tio-data/models/recommendation';
import type RouterService from '@ember/routing/router-service';

interface S {
  Args: {
    model: LoanSummary;
  };
}

export default class PslfDashboardForgivenessEstimator extends Component<S> {
  @service declare router: RouterService;

  didSave = (recommendation: RecommendationModel) => {
    this.router.transitionTo(
      'authenticated.pslf.dashboard.forgiveness-estimator.results',
      recommendation
    );
  };

  <template>
    <TioPageBreadcrumbs class="mb-4" as |b|>
      <b.crumb @route="authenticated.pslf.dashboard.index" @label="Dashboard" />
      <b.crumb
        @route="authenticated.pslf.dashboard.forgiveness-estimator.index"
        @label="Forgiveness Estimator"
      />
    </TioPageBreadcrumbs>

    <Section>
      <:header>{{t "pslf_dashboard.actions.forgiveness_estimator"}}</:header>
      <:body>
        <div class="tio-stack-center md:flex-row md:justify-center md:items-start">
          <ForgivenessEstimatorForgivenessEstimatorForm
            @application="PSLF"
            @loanSummary={{@model}}
            @didSave={{this.didSave}}
            class="max-w-[35rem]"
          />
          <div class="md:ml-10">
            <div class="p-6">
              {{svgJar
                "infographic-screen"
                width="100%"
                role="img"
                desc=(t "svg.infographic_screen")
              }}
            </div>
          </div>
        </div>
      </:body>
    </Section>
  </template>
}
